var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46179 4.70522H9.57085L5.21816 0.352539L0.865479 4.70522H3.97454V17.1415H0.865479L5.21816 21.4942L9.57085 17.1415H6.46179V4.70522ZM11.4363 2.21798V4.70522H26.3598V2.21798H11.4363ZM11.4363 19.6287H26.3598V17.1415H11.4363V19.6287ZM11.4363 12.167H26.3598V9.67972H11.4363V12.167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidth);
export default __webpack_public_path__ + "static/media/width.6643bf3684de85141e5a8eacb18965e7.svg";
export { ForwardRef as ReactComponent };